import React, { useState } from "react";
import Fuse from "fuse.js";

const Chatbot = () => {
  const qaPairs = [
    { question: "What kind of nonsense is this", answer: "What do you mean?" },
    { question: "Put me on the Council and not make me a Master?", answer: "It's a great honor." },
    { question: "That's never been done in the history of the Jedi.", answer: "Perhaps it's a new tradition." },
    { question: "Calm down, Anakin.", answer: "I'm trying to be calm." },
    { question: "You have been given a great honor.", answer: "I understand, but it's still unfair." }
  ];

  // Fuse.js for better matching
  const fuse = new Fuse(qaPairs, { keys: ["question"], threshold: 0.4 });

  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");

  const handleSendMessage = () => {
    if (!input.trim()) return;

    const result = fuse.search(input);
    const botReply = result.length > 0 ? result[0].item.answer : "Please ask a valid question.";

    setMessages([...messages, { text: input, sender: "user" }, { text: botReply, sender: "bot" }]);
    setInput("");
  };

  return (
    <div className="max-w-md mx-auto p-4 bg-gray-100 rounded-lg shadow-md">
      <div className="h-64 overflow-y-auto border border-gray-300 p-2 rounded">
        {messages.map((msg, index) => (
          <div
            key={index}
            className={`chat ${msg.sender === "user" ? "chat-end" : "chat-start"}`}
          >
            <div
              className={`chat-bubble ${msg.sender === "user" ? "chat-bubble-primary" : "chat-bubble-secondary"}`}
            >
              {msg.text}
            </div>
          </div>
        ))}
      </div>
      <div className="mt-2 flex">
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Ask something..."
          className="input input-bordered w-full"
        />
        <button onClick={handleSendMessage} className="btn btn-primary ml-2">
          Send
        </button>
      </div>
    </div>
  );
};

export default Chatbot;
